<template>
  <div v-if="modalId !== null">

    <div v-if="action === 'create' || action === 'edit'" class="modal fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <template v-if="action === 'create'">
              <h4 class="modal-title">Create new Project</h4>

              <small v-if="workflowSelected === null" class="font-bold">Choose the most adapted workflow for your project below</small>
              <small v-else class="font-bold">Edit your project information</small>

            </template>
            <template v-else>
              <h4 class="modal-title" v-if="project">Edit Project : {{project.name}}</h4>
              <small class="font-bold">Edit project info</small>
            </template>
          </div>
          <form v-on:submit="saveProject">

            <div class="modal-body">
              <template v-if="action === 'create' && workflowSelected === null">
                <workflow-box :workflows="workflows" v-model="workflowSelected"/>
              </template>
              <template v-else>
                <div class="modal-body">
                  <div class="form-group">
                    <label class="control-label required" for="name">Project name</label>
                    <input v-model="name" type="text" placeholder=""
                           title="" value="" name="name" id="name"
                           class="form-control">
                    <span v-if="errorName" class="help-block text-danger">{{this.errorName}}</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="description">Project description</label>
                    <summernote v-model="description" :air-mode="false" id="description" :height="'200'"></summernote>
                    <span class="help-block m-b-none hide">Description can make 255 character</span>
                    <span v-if="errorDescription" class="help-block text-danger">{{this.errorDescription}}</span>
                  </div>

                  <div class="form-group">
                    <label class="control-label" for="portfolio">Project portfolio</label>
                    <v-select2 id="portfolio" :options="portfolios" label="name" v-model="portfolioSelected" :clearable="true"
                               placeholder="Select a portfolio" />
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="workflow">Workflow</label>
                    <v-select2 id="workflow" :options="workflowsEnabled" label="name" v-model="workflowSelected" :clearable="false"
                               placeholder="Select a workflow" />
                  </div>

                  <template v-if="action === 'edit' && project.workflow_id !== 1 && project.question && ($auth.check('broker') || $auth.check('manager') || $auth.check('super_admin'))">
                    <div class="form-group" id ="consultantsList">
                      <label class="control-label" for="consultant">Broker</label>
                      <v-select2 v-if="consultants" id="consultant" :options="consultants" :dropdownParent="'consultantsList'"
                                 placeholder="Select a broker" v-model="consultant" :searchable="true"  label="email">
                        <template slot="option" slot-scope="option">
                          <span><b>{{ option.firstname }} {{ option.lastname }}</b><small> {{ option.email }}</small></span>
                        </template>
                      </v-select2>
                    </div>

                  </template>

                  <div style="text-align: right;margin-top: 10px">
                    <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
                  </div>
                </div>
              </template>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
              <template v-if="action === 'create'">

                <vue-ladda v-if="workflowSelected !== null" type="submit" :loading="submitProject.loading" class="btn btn-info" :data-style="submitProject.dataStyle">Create new Project</vue-ladda>

              </template>
              <template v-else>
                <vue-ladda type="submit" :loading="submitProject.loading" class="btn btn-info" :data-style="submitProject.dataStyle">Save Changes</vue-ladda>

              </template>
            </div>
          </form>

        </div>
      </div>
    </div>

    <div v-else-if="this.action === 'delete'" class="modal fade hmodal-danger" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Delete Project</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to delete this project: {{project.name}}?</h3>
            <div>
              <span>Deleting a project is irreversible</span>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <vue-ladda type="submit" :loading="submitProject.loading" class="btn btn-danger" :data-style="submitProject.dataStyle" v-on:click="deleteProject">Delete Project</vue-ladda>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="this.action === 'share'" class="modal fade hmodal-fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Share Project : {{project.name}}</h4>
          </div>

          <form v-on:submit="shareProject">

            <div class="modal-body">
              <div v-if="project.shared_with.length !== 0">
                <label>Shared with: </label>
                <div class="row">

                  <div class="col-xs-3" v-for="(user, key) in project.shared_with" :key="key">

                    <div class="hpanel">
                      <div class="panel-heading" style="height: 40px;box-shadow:none">
                        <div class="pull-right" v-if="project.owner_id === $auth.user().id">
                          <button type="button" class="btn btn-danger btn-xs btn-outline" @click="unShare(user)">
                            <i class="fa fa-remove"></i> remove
                          </button>
                        </div>
                      </div>
                      <div class="panel-body file-body" style="padding: 10px;display:block;border-top: 0">
                        <div style="height: 130px; max-width: 100%;" class="text-center">
                          <img :alt="user.lastname + ' ' + user.firstname"
                               :src="$apiUrl + 'uploads/user/' + (user.picture === null ? 'avatar.png' : 'profile/' + user.picture)"
                               class="img-circle" style="height: 100px;width: 100px;margin: 15px 0">
                        </div>
                      </div>
                      <div class="panel-footer" style="display:block">{{user.lastname}} {{user.firstname}}</div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-xs-12">
                  <label class="col-sm-3 control-label">Share With:</label>
                  <div class="col-sm-9 hide">
                    <select v-model="shareWithSelected" class="m-b form-control">
                      <option v-for="(type, key) in shareWith" :key="key">{{type}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group m-b-sm" v-if="shareWithSelected ==='College not registered'">
                <div class="col-sm-6 m-b">
                  <input v-model.trim="firstName" type="text" placeholder="First Name"
                         title="" value="" name="firstName" id="firstName" required
                         class="form-control">
                  <span v-if="errorFirstName" class="help-block text-danger">{{this.errorFirstName}}</span>
                </div>
                <div class="col-sm-6 m-b">
                  <input v-model.trim="lastName" type="text" placeholder="Last Name"
                         title="" value="" name="lastName" id="lastName" required
                         class="form-control">
                  <span v-if="errorLastName" class="help-block text-danger">{{this.errorLastName}}</span>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 m-b">
                  <input v-model.trim="email" type="text" placeholder="Email address"
                         title="" value="" name="email" id="email" required
                         class="form-control">
                </div>
                <span v-if="errorEmail" class="help-block text-danger">{{this.errorEmail}}</span>
              </div>
              <div class="form-group">
                <label class="control-label" for="comment">Add comment to your message:</label>
                <summernote v-model="comment" :air-mode="false" id="comment" :height="'120'"></summernote>
                <span class="help-block m-b-none hide">Description can make 255 character</span>
              </div>

              <div style="text-align: right;margin-top: 10px">
                <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
              <vue-ladda type="submit" :loading="submitProject.loading" class="btn btn-info" :data-style="submitProject.dataStyle">Share Project</vue-ladda>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-else-if="this.action === 'duplicate'" class="modal fade hmodal-fade" :id="modalId" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Duplicate Project : {{project.name}}</h4>
          </div>

          <form v-on:submit="duplicateProject">

            <div class="modal-body">
              <div class="form-group">
                <label class="control-label required" for="name">Project name:</label>
                <input v-model.trim="duplicateName" type="text" placeholder="Project name"
                       id="duplicateName" class="form-control">
                <span v-if="errorDuplicateName" class="help-block text-danger">{{this.errorDuplicateName}}</span>

              </div>

              <div style="text-align: right;margin-top: 10px">
                <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
              <vue-ladda type="submit" :loading="submitProject.loading" class="btn btn-info" :data-style="submitProject.dataStyle">Duplicate Project</vue-ladda>
            </div>
          </form>
        </div>
      </div>
    </div>
    <limit-plan ref="limitPlan" :on-hidden="() => $emit('input', null)"></limit-plan>
  </div>

</template>

<script>
import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'
import WorkflowBox from './WorkflowBox'
import Summernote from '../utils/Summernote'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {
    Summernote,
    WorkflowBox,
    VueLadda,
    vSelect2,
    LimitPlan
  },
  props: ['project', 'value', 'refresh', 'portfolio'],
  name: 'ActionModalProject',
  watch: {
    workflowSelected: function (workflowSelected) {
      if (workflowSelected === 'upgrade') {
        $('#' + this.modalId + '').modal('toggle')
        this.$router.push({name: 'Plans'})
        workflowSelected = null
      }
    }
  },
  methods: {
    saveProject: function (event) {
      // debugger
      event.preventDefault()
      this.submitProject.loading = true

      let method = this.action === 'create' ? 'post' : 'patch'

      let data = {
        name: this.name,
        description: this.description,
        portfolio_id: (this.portfolioSelected !== null ? this.portfolioSelected.id : null)
      }
      if (this.workflowSelected !== null) {
        data.workflow_id = this.workflowSelected.id
      }
      if (this.consultant !== null) {
        data.consultant_id = this.consultant.id
      }

      this.axios[method]('/project/' + (this.project !== null ? this.project.id : ''), data)
        .then((response) => {
          if (typeof this.refresh !== 'undefined') {
            this.refresh(response.data)
          }
          $('#' + this.modalId + '').modal('hide')

          if (this.action === 'create') {
            this.$auth.fetch()
            this.$router.push({name: 'ProjectDetails', params: {id: response.data.id}})
            this.$salesMachine.createProject({project_name: this.name, project_id: response.data.id})
          }
          this.name = null
          this.description = null
          this.errorName = null
          this.errorDescription = null
        })
        .catch((error) => {
          if (error.response.status === 400) {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorName = errors['name'][0]
                break
              case 2:
                this.errorDescription = errors['description'][0]
                break
            }
          }
        })
        .finally(() => {
          this.submitProject.loading = false
        })
    },
    deleteProject: function () {
      this.submitProject.loading = true

      this.axios.delete('/project/' + this.project.id, {
        portfolio_id: (this.portfolioSelected !== null ? this.portfolioSelected.id : null)
      })
        .then((response) => {
          this.refresh(Date.now())
          this.$auth.fetch()
          $('#' + this.modalId + '').modal('toggle')
        })
        .catch((error) => {
          if (typeof error.response.data !== 'undefined') {
            if (error.response.data.code === 10) {
              this.$notify({
                type: 'danger',
                title: 'This project can\'t be deleted because one mailing has been sent',
                placement: 'bottom-right'
              })
            }
          }
          $('#' + this.modalId + '').modal('toggle')
        })
        .finally(() => {
          this.submitProject.loading = false
        })

      event.preventDefault()
    },
    shareProject: function (event) {
      event.preventDefault()
      this.submitProject.loading = true
      let data = {
        email: this.email,
        comment: this.comment
      }
      if (this.consultant !== null) {
        data.consultant_id = this.consultant.id
      }

      if (this.shareWithSelected !== 'Registered Account') {
        data.shareWith = 'new'
        data.firstName = this.firstName
        data.lastName = this.lastName
      } else {
        data.shareWith = 'user'
      }

      this.axios.post('/project/' + this.project.id + '/share', data)
        .then((response) => {
          $('#' + this.modalId + '').modal('hide')
          this.email = null
          this.comment = null
          this.errorEmail = null
          this.errorLastName = null
          this.errorFirstName = null
          this.firstName = null
          this.lastName = null
          this.$notify({
            type: 'success',
            title: 'Project has been shared successfully',
            placement: 'bottom-right'
          })
          if (typeof this.refresh !== 'undefined') {
            this.refresh(this.$moment().format())
          }
          this.$salesMachine.shareProject({project_name: this.project.name, project_id: this.project.id})
        })
        .catch((error) => {
          if (error.response.status === 400) {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorEmail = errors['email'][0]
                break
            }
          } else {
            this.$notify({
              type: 'error',
              title: 'An error occurred during the share project operation! Please try again or refresh the current page.',
              placement: 'bottom-right'
            })
          }
        })
        .finally(() => {
          this.submitProject.loading = false
        })
    },
    unShare: function (user) {
      this.axios.delete('/project/' + this.project.id + '/unShare/' + user.id)
        .then((response) => {
          if (typeof this.refresh !== 'undefined') {
            this.refresh(this.$moment().format())
          }
        }).catch((error) => {

        })
    },
    duplicateProject: function (event) {
      event.preventDefault()
      this.submitProject.loading = true

      this.axios.post('/project/' + this.project.id + '/duplicate/', {name: this.duplicateName})
        .then((response) => {
          $('#' + this.modalId + '').modal('hide')

          if (typeof this.refresh !== 'undefined') {
            this.refresh(this.$moment().format())
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorDuplicateName = errors['name'][0]
                break
            }
          } else {
            this.$notify({
              type: 'danger',
              title: 'An error occurred during the duplicate project operation! Please try again or refresh the current page.',
              placement: 'bottom-right'
            })
            $('#' + this.modalId + '').modal('hide')
          }
        })
        .finally(() => {
          this.submitProject.loading = false
        })
    },
    init: function () {
      this.action = this.value

      switch (this.action) {
        case 'create' :
          this.modalId = 'createProject'
          break
        case 'edit' :
          this.modalId = 'editProject-' + this.project.id
          break
        case 'delete' :
          this.modalId = 'deleteProject-' + this.project.id
          break
        case 'share' :
          this.modalId = 'shareProject-' + this.project.id
          break
        case 'duplicate' :
          this.modalId = 'duplicateProject-' + this.project.id
          this.duplicateName = this.project.name + ' (copy)'
          break
      }

      if (this.project !== null) {
        this.name = this.project.name
        this.description = this.project.description
        this.portfolioSelected = this.project.my_portfolio && this.project.my_portfolio.length !== 0 ? this.project.my_portfolio[0] : null
        this.workflowSelected = this.project.workflow != null ? this.project.workflow : null
        this.consultant = this.project.question !== null ? this.project.question.consultant : null
      } else {
        this.name = null
        this.description = null
        this.portfolioSelected = this.portfolio ? this.portfolio : null
      }

      if (this.action === 'create' || this.action === 'edit') {
        this.axios.get('/portfolios')
          .then((response) => {
            this.portfolios = response.data
          })
          .catch(function (error) {
          })
        if (this.project !== null) {
          this.axios.get('/project/' + this.project.id + '/consultants')
            .then((response) => {
              this.consultants = response.data
            })
            .catch(function (error) {
            })
        }
      }

      this.axios.get('/workflows')
        .then((response) => {
          this.workflows = response.data
          this.workflowsEnabled = response.data.filter((workflow) => {
            return workflow.enable === 1
          })
        })
        .catch(function (error) {
        })
    },
    showModal: function () {
      let limitPlan = null

      if (this.$user.isBasic()) {
        limitPlan = 'basic_project'
      } else if ((this.action === 'create' || this.action === 'duplicate') &&
          this.$auth.user().plan.nb_project_storage_remained === 0) {
        limitPlan = 'storage_limit'
      }

      if (limitPlan !== null) {
        this.$refs.limitPlan.show(limitPlan)
        return false
      }

      $('#' + this.modalId).modal()
      $('#' + this.modalId).on('hidden.bs.modal', (e) => {
        this.$emit('input', null)
      })

      setTimeout(() => {
        $('[data-toggle="popover"]').popover({
          trigger: 'hover',
          placement: 'top',
          container: 'body',
          content: $('#popover-wrong-plan').html(),
          html: true
        })
      }, 500)
    },
    onCancel: function () {
    }
  },
  mounted () {
    this.showModal()
  },
  data () {
    return {
      action: null,
      name: null,
      description: '',
      errorName: null,
      errorDescription: null,
      workflows: [],
      workflowsEnabled: [],
      workflowSelected: null,
      portfolioSelected: null,
      consultant: null,
      submitProject: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      modalId: null,
      portfolios: [],
      consultants: [],
      email: null,
      comment: null,
      errorEmail: null,
      duplicateName: null,
      errorDuplicateName: null,
      shareWithSelected: 'College not registered',
      shareWith: ['Registered Account', 'College not registered'],
      firstName: null,
      lastName: null,
      errorFirstName: null,
      errorLastName: null
    }
  },
  beforeMount () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/ActionModalProject.vue